import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import useTranslation from 'next-translate/useTranslation'

import queryGraphql from '@shared-components/queryGraphql'
import { CURRENT_MATCHES_V2 } from '@graphql/fixtures/fixtures.query'
import { checkRedirectionStatus, getDateRange, getTimeZone, handleApiError } from '@shared/utils'
import { pageLoading } from '@shared/libs/allLoader'
import Error from '@shared/components/error'
import { GET_ARTICLE_ID } from '@graphql/article/article.query'

const FixtureContent = dynamic(() => import('@shared-components/fixtureContent'), { loading: () => pageLoading() })
const ScheduleContent = dynamic(() => import('@shared-components/scheduleContent'), { loading: () => pageLoading() })

function CricketSchedule({ data, seoData, dStartDate }) {
  const { t } = useTranslation()
  return (
    <FixtureContent type="scheduleByMonth" title={t('common:Fixtures')} seoData={seoData}>
      <ScheduleContent data={data} currentDate={dStartDate} />
    </FixtureContent>
  )
}

CricketSchedule.propTypes = {
  data: PropTypes.object,
  seoData: PropTypes.object,
  dStartDate: PropTypes.string
}

export default Error(CricketSchedule)

export async function getServerSideProps({ res, resolvedUrl, query }) {
  try {
    res.setHeader('Cache-Control', 'public, max-age=120')
    const { data: seoData } = await queryGraphql(GET_ARTICLE_ID, { input: { sSlug: resolvedUrl.replaceAll('/', '').split('?')[0] || '' } })
    // Check Redirection
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seoData?.getSeoData, query?.amp)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj
    const { dStartDate, dEndDate } = getDateRange(0, 15, query?.date)

    const { data } = await queryGraphql(CURRENT_MATCHES_V2, {
      input: { eCategory: 'i', dStartDate, dEndDate, sTimezone: getTimeZone(), nSkip: 1 }
    })
    return {
      props: {
        data,
        dStartDate,
        seoData: seoData?.getSeoData
      }
    }
  } catch (e) {
    // console.log({ e })
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
